'use strict';
const Ajax = require('common/infra/ajax');

class API {
    /**
     * Action を取得する
     *
     * @param projectId
     * @param actionId
     * @returns {*}
     */
    getAction(projectId, actionId, options = {}) {
        return Ajax.GET(`/api/projects/${projectId}/actions/${actionId}`, options);
    }

    /**
     * Action を作成する
     *
     * @param projectId
     * @param actionJSON
     * @returns {*}
     */
    create(projectId, actionJSON) {
        return Ajax.POST(`/api/projects/${projectId}/actions`, actionJSON);
    }

    /**
     * Action を更新する
     *
     * @param projectId
     * @param actionID
     * @param actionJSON
     * @returns {*}
     */
    update(projectId, actionID, actionJSON) {
        return Ajax.PUT(`/api/projects/${projectId}/actions/${actionID}`, actionJSON);
    }

    /**
     * Action を削除する
     *
     * @param projectId
     * @param actionID
     * @returns {*}
     */
    delete(projectId, actionID) {
        return Ajax.DELETE(`/api/projects/${projectId}/actions/${actionID}`);
    }

    /**
     * Action の子供の一覧を取得する
     *
     * @param projectId
     * @param actionId
     * @returns {*}
     */
    getActionChildren(projectId, actionId) {
        return Ajax.GET(`/api/projects/${projectId}/actions/${actionId}/children`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./process/infra/api/action/index.js